import { requestPlatform, requestBase } from '@/plugins/axios'
export function getFactory() {
    return requestPlatform({
        url: 'factory/getFactoryName',
        method: 'GET'
      })
}
// {query,pagenum,pagesize}
export function getMachineList(params) {
    return requestPlatform({
        // url: 'MachineState/findByFactoryName', //hcy修改了接口
        url: 'machine/list',
        method: 'GET',
        params: params
      })
}
// {machineid}
export function generatePairCode(id) {
   return requestBase({
        url: `v1/platform/paircode/${id}`,
        method: 'GET'
      })
}
// {time,uuid,factory,machineid}
export function unPair(data) {
    return requestBase({
        url: 'v1/platform/machine-state/unpair',
        method: 'POST',
        data: data
      })
}
